import { Application } from '@hotwired/stimulus';
import '@lottiefiles/lottie-player';

const app = Application.start();

import LottieController from 'banzai/pendant/front/shared/lottie.js';

app.register('lottie', LottieController);
